/**
 * Admin Notification Types
 * Domain model for admin panel notifications
 */
export var AdminNotificationType;
(function (AdminNotificationType) {
    AdminNotificationType["NEW_ORDER"] = "NEW_ORDER";
    AdminNotificationType["ORDER_ASSIGNED"] = "ORDER_ASSIGNED";
    AdminNotificationType["ORDER_STATUS_CHANGED"] = "ORDER_STATUS_CHANGED";
    AdminNotificationType["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    AdminNotificationType["ORDER_READY"] = "ORDER_READY";
    AdminNotificationType["ORDER_DELIVERED"] = "ORDER_DELIVERED";
    AdminNotificationType["NEW_CHAT"] = "NEW_CHAT";
    AdminNotificationType["NEW_MESSAGE"] = "NEW_MESSAGE";
    AdminNotificationType["INVENTORY_LOW"] = "INVENTORY_LOW";
    AdminNotificationType["INVENTORY_RESERVED"] = "INVENTORY_RESERVED";
    AdminNotificationType["INVENTORY_COMMITTED"] = "INVENTORY_COMMITTED";
    AdminNotificationType["PROCESS_ALERT"] = "PROCESS_ALERT";
    AdminNotificationType["SYSTEM_ALERT"] = "SYSTEM_ALERT";
})(AdminNotificationType || (AdminNotificationType = {}));
export var AdminNotificationCategory;
(function (AdminNotificationCategory) {
    AdminNotificationCategory["ORDERS"] = "ORDERS";
    AdminNotificationCategory["CHATS"] = "CHATS";
    AdminNotificationCategory["INVENTORY"] = "INVENTORY";
    AdminNotificationCategory["PROCESSES"] = "PROCESSES";
    AdminNotificationCategory["SYSTEM"] = "SYSTEM";
})(AdminNotificationCategory || (AdminNotificationCategory = {}));
// Socket event types
export var AdminNotificationSocketEvent;
(function (AdminNotificationSocketEvent) {
    AdminNotificationSocketEvent["NEW_NOTIFICATION"] = "admin:notification";
    AdminNotificationSocketEvent["NOTIFICATION_READ"] = "admin:notification_read";
    AdminNotificationSocketEvent["NOTIFICATION_DELETED"] = "admin:notification_deleted";
})(AdminNotificationSocketEvent || (AdminNotificationSocketEvent = {}));
